import React from "react";
import Konn3ctHeader from "../Header & Footer/Konn3ctHeader";
import Kpricing from "./PriceP1";
// import FeatP2 from "../Features Page/Konn3ctF 2";
import Footer from "../Header & Footer/kfooter";

const PricingPage = () => {
  return (
    // <div className="relative w-full bg-cover bg-center  text-white font-sans">
        <div className="relative z-10 min-h-screen w-full bg-cover bg-center text-white-900 font-sans overflow-hidden pt-[64px] sm:pt-[80px] md:pt-[100px]">

    
      {/* Navbar */}
      <div
        className="absolute top-0 left-0 w-full h-[61vh] -z-10"
        style={{
          backgroundImage: `
            repeating-linear-gradient(to right, rgba(128, 128, 128, 0.08) 0, rgba(128, 128, 128, 0.08) 1px, transparent 1px, transparent 100px),
            repeating-linear-gradient(to bottom, rgba(128, 128, 128, 0.08) 0, rgba(128, 128, 128, 0.08) 1px, transparent 1px, transparent 100px)
          `,
        }}
      />
      <Konn3ctHeader />
      {/* Hero Section */}
      {/* <section className="relative text-center mt-11 px-6 w-full"> */}
      <section className="relative text-center mt-11 px-4 sm:px-6 w-full z-20">
        <h1 className="text-4xl md:text-5xl font-bold leading-tight text-black">
          Fair pricing <br /> that grows with you
        </h1>
        <p className="mt-4 text-base  max-w-2xl mx-auto text-black">
          Join thousands of companies achieving faster resolution times, <br />{" "}
          higher team efficiency, and better satisfaction.
        </p>
      </section>

             <Kpricing/>


              {/* <div className="relative z-20 mt-10 md:mt-20 space-y-12 md:space-y-16"> */}

              <div className="relative z-20 mt-10 space-y-16">
                     
                      {/* <FeatP2 /> */}
                      <Footer />
                    </div>

    </div>
  );
};

export default PricingPage;
